import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getEquipmentFactplaces: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].GET_EQUIPMENT_FACTPLACES,
	},
	getEquipmentFactplace: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].GET_EQUIPMENT_FACTPLACE,
	},
	createEquipmentFactplace: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].CREATE_EQUIPMENT_FACTPLACE,
	},
	patchEquipmentFactplace: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].PATCH_EQUIPMENT_FACTPLACE,
	},
	putEquipmentFactplace: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].PUT_EQUIPMENT_FACTPLACE,
	},
	deleteEquipmentFactplace: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].DELETE_EQUIPMENT_FACTPLACE,
	},
}
